import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import LoadingModal from '../../MOLECULES/LOADING/LoadingModal'
import SideBar from './MENU/SideBar'

const LayoutDojang = () => {
  return (
    <>
      <div className='bg-body'>
        <div className='main-wrap'>
          <SideBar />
          <Suspense fallback={<LoadingModal />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  )
}

export default LayoutDojang
